export const enum KeyModifiers {
  Alt = 'alt',
  Ctrl = 'ctrl',
  None = 'none',
  Shift = 'shift',
}
